import type { IconProps } from './types';

export const LoadingIcon = (props: IconProps) => {
  const {
    width = 17,
    height = 16,
    color = 'currentColor',
    className = 'animate-spin',
  } = props;

  return (
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 17 16"
      fill="none"
      className={className}
    >
      <path
        d="M0.25 7.61133C0.250092 4.44393 2.05628 1.6995 4.69336 0.333984C5.06117 0.143539 5.51363 0.287484 5.7041 0.655273C5.89449 1.02298 5.75134 1.47545 5.38379 1.66602C3.22137 2.78567 1.75009 5.02983 1.75 7.61133C1.75 11.3075 4.76743 14.3125 8.5 14.3125C12.2326 14.3125 15.25 11.3075 15.25 7.61133C15.2499 5.02983 13.7786 2.78567 11.6162 1.66602C11.2487 1.47545 11.1055 1.02298 11.2959 0.655273C11.4864 0.287485 11.9388 0.14354 12.3066 0.333984C14.9437 1.6995 16.7499 4.44393 16.75 7.61133C16.75 12.1452 13.0518 15.8125 8.5 15.8125C3.9483 15.8125 0.25 12.1452 0.25 7.61133Z"
        fill={color}
      />
    </svg>
  );
};
